console.log('from ae_theme/assets/src/index.js asdf')
// Import our custom CSS
import './scss/styles.scss'

import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

// import 'bootstrap';
import 'moment';
import 'platform';
import * as _ from 'underscore';
// import '@fancyapps/fancybox';
// _.mixin(_.deepclone);
import skipToContent from '@ae-theme-src/js/modules/classes/skipToContent.js';
import utility from '@ae-theme-src/js/modules/classes/utility.js';
import aeAccordion from '@ae-blocks/accordion_start/js/modules/classes/aeAccordion.js';
import mainNav from '@ae-blocks/autonav/templates/accessible/js/modules/classes/mainNav.js';
import mobileNav from '@ae-blocks/autonav/templates/mobile/js/modules/classes/mobileNav.js';

const skipToContentInst = new skipToContent();
const utilityInst = new utility();
const aeAccordionConst = new aeAccordion();
const mainNavConst = new mainNav();
const mobileNavConst = new mobileNav();